import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const parkingList = createAsyncThunk('parking/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_parking`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'parking_type': data?.parking_type,
                'zone_id': data?.zone_id,
                'level_id': data?.level_id,
                'unit_id': data?.unit_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const parkingDetails = createAsyncThunk('parking/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_parking/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addParking = createAsyncThunk('parking/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'premise_parking',
            data: {
                "premise_id": data?.values?.premise_id,
                "parking_name": data?.values?.parking_name,
                "parking_type": data?.values?.parking_type,
                "zone_id": data?.values?.zone_id,
                "level_id": data?.values?.level_id,
                "unit_id": data?.values?.unit_id,
                "four_wheeler": data?.values?.cars_allowed,
                "two_wheeler": data?.values?.two_wheeler_allowed,
                "heavy_vehicle": data?.values?.heavy_vehicle,
                "description": data?.values?.remark,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateParking = createAsyncThunk('parking/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'premise_parking',
            data: {
                "parking_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "parking_name": data?.values?.parking_name,
                "parking_type": data?.values?.parking_type,
                "zone_id": data?.values?.zone_id,
                "level_id": data?.values?.level_id,
                "unit_id": data?.values?.unit_id,
                "four_wheeler": data?.values?.cars_allowed,
                "two_wheeler": data?.values?.two_wheeler_allowed,
                "heavy_vehicle": data?.values?.heavy_vehicle,
                "description": data?.values?.remark,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delParking = createAsyncThunk('parking/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `premise_parking/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const parking = createSlice({
    name: 'parking',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(parkingList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(parkingList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(parkingList.rejected, (state, action) => {
            state.loading = false;
        })

        builder.addCase(parkingDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default parking.reducer;